import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBrokerConsultantBanner.css';
import { NBSP } from 'shared/constants/symbols';

interface INewbuildingBrokerConsultantBannerProps {
  url: string;
  buttonText?: string;
  onClick: () => void;
}

/* istanbul ignore next */
export const NewbuildingBrokerConsultantBanner: React.FC<INewbuildingBrokerConsultantBannerProps> = ({
  url,
  buttonText = 'О сервисе',
  onClick,
}) => {
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className={styles['container']}
      data-testid="NewbuildingBrokerConsultantBanner"
      onClick={onClick}
    >
      <div className={styles['inner']}>
        <UIHeading1>
          Подберём и{NBSP}поможем купить квартиру в{NBSP}новостройке. Бесплатно!
        </UIHeading1>
        <div className={styles['description-wrapper']}>
          <UIText1>Найдём жильё под{NBSP}ваш запрос</UIText1>
        </div>
        <div>
          <Button>{buttonText}</Button>
        </div>
      </div>
    </a>
  );
};
